import React, { useMemo } from 'react';

import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import { Box } from '@/shared/ui';

import DataTableIcon from '@/assets/icons/DataTable';
import FileWidgetIcon from '@/assets/icons/FileWidget';
import FWDChartIcon from '@/assets/icons/FWDChart';
import HighlightPriceIcon from '@/assets/icons/HighlightPrice';
import SeasonalChartIcon from '@/assets/icons/SeasonalChart';
import SimpleChartIcon from '@/assets/icons/SimpleChart';
import getWidgetType from '@/features/dashboard/lib/getWidgetType';
import type { MarketTabWidgets } from '@/features/markets';

export const useWidgetOptions = (selectedTab: undefined | MarketTabWidgets) => {
  return useMemo(() => {
    if (!selectedTab) return [];
    return selectedTab.widgets.map(widget => {
      let widgetName;
      let widgetIcon;
      let previewImage;
      let height;
      const type = getWidgetType(widget);
      switch (widget.type) {
        case 'tiles':
          widgetIcon = <HighlightPriceIcon />;
          widgetName = 'Highlighted price';
          previewImage = '/img/preview/tiles.png';
          height = 50;
          break;
        case 'minitable':
          widgetIcon = <TableChartOutlinedIcon sx={{ fontSize: '12px' }} />;
          widgetName = 'Minitable';
          previewImage = '/img/preview/minitable.png';
          height = 150;
          break;
        case 'feed':
          widgetIcon = <MessageOutlinedIcon sx={{ fontSize: '12px' }} />;
          widgetName = 'Feed';
          previewImage = '/img/preview/feed.png';
          height = 150;
          break;
        case 'table':
          widgetIcon = <DataTableIcon />;
          widgetName = 'Data Table';
          previewImage = '/img/preview/data-table.png';
          height = 150;
          break;
        case 'file_list':
          widgetIcon = <FileWidgetIcon />;
          widgetName = 'File list viewer';
          previewImage = '/img/preview/files-widget.png';
          height = 100;
          break;
        case 'graph':
          switch (type) {
            case 'simple':
              widgetIcon = <SimpleChartIcon />;
              widgetName = 'History chart';
              previewImage = '/img/preview/history-chart.png';
              height = 150;
              break;
            case 'forwardSimple':
              widgetIcon = <FWDChartIcon />;
              widgetName = 'Forward curve chart';
              previewImage = '/img/preview/fwd-chart.png';
              height = 150;
              break;
            case 'seasonal':
              widgetIcon = <SeasonalChartIcon />;
              widgetName = `Seasonal chart`;
              previewImage = '/img/preview/seasonal-chart.png';
              height = 150;
              break;
            default:
              break;
          }
          break;
        default:
          break;
      }

      return {
        label: widget.name,
        value: `${widget.name}-{${type}}`,
        previewImage,
        height,
        info: (
          <Box
            sx={{
              display: 'flex',
              fontSize: '12px',
              alignItems: 'center',
              color: 'gx.subtext',
              fontWeight: 600,
              gap: 0.5,
              whiteSpace: 'nowrap'
            }}
          >
            {widgetIcon}
            {widgetName}
          </Box>
        )
      };
    });
  }, [selectedTab]);
};
